import { render, staticRenderFns } from "./TipologiaservizioList.vue?vue&type=template&id=dd6a12dc&"
import script from "./TipologiaservizioList.vue?vue&type=script&lang=ts&"
export * from "./TipologiaservizioList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports